import Axios from "axios";

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const API_TOKEN= process.env.REACT_APP_API_TOKEN;

const api = Axios.create({
    baseURL: API_ENDPOINT,
    timeout: 100000,
    /*withCredentials: true,*/
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
        'X-Api-Key': API_TOKEN
    }
});

export const renew = function (){
    delete api.defaults.headers.common['Authorization'];
    sessionStorage.removeItem('token');
    window.location.href="./sign-in";
}

export const clear = function (){
    delete api.defaults.headers.common['Authorization'];
    sessionStorage.removeItem('token');
}

export const setAccessToken = () => {
    api.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(sessionStorage.getItem('accessInfo'))?.accessToken}`;
}

export default api;
